import { DELETE_SUCCESS, LOAD_SUCCESS } from '../utils/constants';

export const userReducer = (state, action) => {
  const {
    type,
    payload: {
      users,
      pagination: { totalItems, page, totalPages, take },
    },
  } = action;

  switch (type) {
    case LOAD_SUCCESS:
      if (state?.users?.length > 0) {
        const stateUserIds = state?.users?.map((item) => item?.id);
        const idExisted = users?.find((item) =>
          stateUserIds?.includes(item?.id)
        );
        if (idExisted) return state;
      }
      return {
        ...state,
        userLoading: false,
        users: [...state?.users, ...users],
        pagination: {
          totalItems,
          page,
          totalPages,
          take,
        },
      };

    case DELETE_SUCCESS:
      return {
        ...state,
        userLoading: false,
        users: state?.users?.map((user) =>
          user?.id === action?.payload?.user?.id ? action?.payload?.user : user
        ),
      };

    default:
      return state;
  }
};
